import React from 'react'
import './style.css'

const Loader = ({classValue}) => {
  return (
    <div className={`loader_container ${classValue ? classValue : ''}`}>
    <div className="loader_child"></div>
  </div>
  )
}

export default Loader